/** Path on Rippling after WIW migration login (Rippling `next` query param). */
export const RIPPLING_MIGRATION_POST_LOGIN_PATH = '/time-products/dashboard/schedules';

const RIPPLING_MIGRATION_SIGN_IN_ORIGIN = 'https://app.rippling.com/sign-in/id';

function buildRipplingMigrationLoginUrl(): string {
  const url = new URL(RIPPLING_MIGRATION_SIGN_IN_ORIGIN);
  url.searchParams.set('noticeBodyKey', 'page.login.wiw.noticeBody');
  url.searchParams.set('next', RIPPLING_MIGRATION_POST_LOGIN_PATH);
  url.searchParams.set('noticeDurationDays', '60');
  url.searchParams.set('brand', 'wiw');
  return url.toString();
}

/** Full sign-in URL for migration flows (notice copy + post-login redirect). */
export const RIPPLING_MIGRATION_LOGIN_URL = buildRipplingMigrationLoginUrl();

export const RIPPLING_MIGRATION_BANNER_REFRESH_LD_FLAG = 'wiwarp-817-migration-banner-refresh';
export const RIPPLING_MIGRATION_SCHEDULE_A_CALL_URL = 'https://meetings.rippling.com/personal?e=bhanley@rippling.com&';
export const RIPPLING_MIGRATION_LIVE_WALKTHROUGH_URL =
  'https://rippling.registration.goldcast.io/repeating-event/cac0d4b8-6419-4094-ac32-923e95142ed3';
export const RIPPLING_MIGRATION_HELP_CENTER_FAQS_URL = 'https://help.wheniwork.com';

export const RIPPLING_TOS_URL = 'https://app.rippling.com/legal/user';
export const RIPPLING_PRIVACY_URL = 'https://app.rippling.com/legal/privacy';
